export default function StatTile({ label, value, sub, accent = "sage", testid }) {
  const accents = {
    sage: "bg-sage-light",
    sand: "bg-sand",
    ochre: "bg-ochre-light",
    terracotta: "bg-terracotta-light",
  };
  return (
    <div
      className={`rounded-3xl p-5 ${accents[accent] || accents.sage}`}
      data-testid={testid}
    >
      <p className="text-[11px] uppercase tracking-[0.18em] font-bold text-slate2">{label}</p>
      <p className="font-heading text-2xl font-extrabold text-charcoal mt-2 leading-tight">{value}</p>
      {sub && <p className="text-xs text-slate2 mt-1">{sub}</p>}
    </div>
  );
}
